import {
    AUTHENTICATING_ZOHO_REQUEST, AUTHENTICATING_ZOHO_SUCCEDDED, AUTHENTICATING_ZOHO_FAILED,
    UPDATING_ZOHO_REQUEST, UPDATING_ZOHO_SUCCEDDED, UPDATING_ZOHO_FAILED,    
    } from '../actionTypes.jsx';  
import { activatingIntegrationSuccedded } from '../integrations';
import axios from 'axios';

  const apiUrl = `${process.env.REACT_APP_API_URL}`;
  const ZOHO_BASE_URL = `${apiUrl}/api/2.0/integrations/zoho`;
  const ZOHO_BASE_URL_V2 = `${apiUrl}/api/2.1/integrations/zoho`;
  
  export function authenticateAccount(code, location){
    return function (dispatch) {
      dispatch(authenticatingAccount());

      const data = {
        code: code,
        location: location
      }
  
      return axios({
        method: 'POST',
        url: ZOHO_BASE_URL_V2,
        params: data
      })
      .then((response) => {
        dispatch(authenticatingAccountSuccedded(response.data));
        dispatch(activatingIntegrationSuccedded(response.data));
      })
      .catch(error =>
        dispatch(authenticatingAccountFailed(error.errors))
      )
    }
  }
  
  function authenticatingAccount(){
    return {
      type: AUTHENTICATING_ZOHO_REQUEST,
      payload: {}
    }
  }
  
  function authenticatingAccountSuccedded(json){
    return {
      type: AUTHENTICATING_ZOHO_SUCCEDDED,
      payload: json
    }
  }
  
  function authenticatingAccountFailed(error){
    return {
      type: AUTHENTICATING_ZOHO_FAILED,
      payload: error
    }
  }


/**
* Update zoho configuration
*/
export function updateConfiguration(configuration){
    return function (dispatch) {
      dispatch(updatingConfiguration());
  
      return axios({
        method: 'PUT',
        url: ZOHO_BASE_URL_V2,
        data: configuration
      })
      .then((response) => {
        dispatch(updatingConfigurationSuccedded(response.data));
        dispatch(activatingIntegrationSuccedded(response.data));
      })
      .catch(error => {
        dispatch(updatingConfigurationFailed(error.errors))
      })
    }
  }
  
  function updatingConfiguration(){
    return {
      type: UPDATING_ZOHO_REQUEST,
      payload: {}
    }
  }
  
  function updatingConfigurationSuccedded(json){
    return {
      type: UPDATING_ZOHO_SUCCEDDED,
      payload: json
    }
  }
  
  function updatingConfigurationFailed(error){
    return {
      type: UPDATING_ZOHO_FAILED,
      payload: error
    }
  }